import { Injectable, computed, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs';
import { ENVIRONMENT } from '@base/lib/core/tokens/environment';

export interface GetCityCountryListRequest {
  city?: string[];
}

export interface GetCityCountryListResponse {
  data: {
    name: string;
    countries: string[];
  }[];
}

@Injectable({
  providedIn: 'root',
})
export class CityCountryService {
  private http = inject(HttpClient);
  private readonly environment = inject(ENVIRONMENT);

  readonly baseUrl = signal(this.environment.api.baseUrl).asReadonly();

  _GetCityCountryListResponse = signal<GetCityCountryListResponse | null>(null);

  readonly cityList = computed(() => {
    const response = this._GetCityCountryListResponse();
    return response?.data.map((item) => item.name) ?? [];
  });

  districtList(countyCode: string | undefined) {
    if (!countyCode)
      return [];
    return this._GetCityCountryListResponse()?.data.find((c) => c.name === countyCode)?.countries ?? [];
  }

  apiGetCityCountryList(request: GetCityCountryListRequest) {
    return this.http.get<GetCityCountryListResponse>(
      `${this.baseUrl()}/api/city-country/list`,
      { params: { ...request } },
    ).pipe(
      tap((res) => {
        this._GetCityCountryListResponse.set(res);
      }),
    );
  }
}
